
// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// libraries
import { SliderModule } from 'primeng/slider';

// Afidium
import { SliderFieldComponent } from './slider-field.component';
import { FormFieldModule } from 'libraries/module/formbuilder/fields/form-field/form-field.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        SliderModule,
        FormFieldModule,
        ReactiveFormsModule,
    ],
    exports: [
        SliderFieldComponent,
    ],
    declarations: [
        SliderFieldComponent,
    ],
    providers: [],
})
export class SliderFieldModule { }
